<template>
  <div class="upload-modal-wrapper">
    <el-dialog
      :visible="dialogDisplay"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @close="closeModal"
      :width="modelWidth"
      custom-class="upload-modal">
      <template #title>
        <div class="dialog-title-box">
          <span>{{titleText}}</span>
          <rhcn-button
            class="icon-button dialog-close-icon"
            size="small"
            @click="dialogDisplay = false"
          ><i class="el-icon-close"></i></rhcn-button>
        </div>
      </template>
      <div v-loading="checking === 1" class="upload-wrapper">
        <div v-if="!uploadFile" class="upload-box">
          <div v-if="templateFileName" class="upload-top">
            <a class="download-temp" :href="'/static/template/' + templateFileName"
              :download="templateFileNameShow || templateFileName">
              {{$t('message.common.downloadTemplate')}}
            </a>
          </div>
          <el-upload
            class="upload-content"
            drag
            action="#"
            :multiple="false"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onUploadChange"
            :accept="accept && FILE_TYPES[accept] ? FILE_TYPES[accept].accept : ''">
            <div class="upload-content-info">
              <span class="margin-bottom-8">附件区域</span>
              <span class="btn-upload">{{$t('message.settlement.uploadFile')}}</span>
            </div>
            <template #tip>
              <span v-if="accept && FILE_TYPES[accept]" class="upload-tips">{{$t('message.upload.supportFileAndSizeTip', { type: FILE_TYPES[accept].ext.join('/'), size: `${maxFileSize}M` })}}</span>
            </template>
          </el-upload>
        </div>
        <div v-if="uploadFile && checking !== 2" class="file-box">
          <div class="file-info">
            <div class="file-icon"><i class="iconfont icon-other1"></i></div>
            <div class="file-content">
              <p class="file-name">{{uploadFile.name}}</p>
              <p class="file-desc">{{gerFileSize(uploadFile.size)}} {{$t('message.dispute.appealFileTime')}}: {{uploadFile.uploadTime}}</p>
            </div>
            <i class="file-operate el-icon-download" @click="onDownloadFile"></i>
            <i class="file-operate el-icon-close" @click="onDeleteFile"></i>
          </div>
          <div v-if="!!errorMsg" class="error-info">
            <i class="el-icon-warning margin-right-10"></i>
            <span class="error-txt">{{errorMsg}}</span>
          </div>
        </div>
        <div v-if="checking === 2" class="success-box">
          <div class="success-info">
            <i class="el-icon-success margin-right-10"></i>
            <span class="success-txt">{{successTips}}</span>
          </div>
        </div>
      </div>
      <template #footer>
        <div v-if="checking !== 2" class="upload-btns">
          <div v-if="!errorMsg">
            <rhcn-button :loading="checking === 1" :disabled="!uploadFile || !!errorMsg" type="primary" size="small" @click="onSubmit">{{$t(confirmBtnText)}}</rhcn-button>
          </div>
          <div v-if="uploadFile && failedFileUrl"><rhcn-button type="primary" size="small" @click="onDownloadFailedFile">下载待处理表单</rhcn-button></div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>

import RhcnButton from '@/components/form/button.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { formatDateDisplay } from '@/utils/tools/time.js';
import { shallowClones } from '@/utils/tools/utils.js';

export default {
  name: 'UploadModal',
  components: {
    RhcnButton,
  },
  props: {
    titleText: {
      type: String,
      default: '',
    },
    modelWidth: {
      type: String,
      default: '620px',
    },
    /**
     * 为true时，确定按钮不显示(默认为false)
     */
    hideConfirmBtn: {
      type: Boolean,
      default: false,
    },
    confirmBtnText: {
      type: String,
      default: 'message.common.submit',
    },
    // 模板名称（static/file目录下文件名, 为下载提供文件路径）
    templateFileName: {
      type: String,
      default: '',
    },
    // 模板名称(下载的文件名)
    templateFileNameShow: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: 'excel',
    },
    maxFileSize: {
      type: Number,
      default: 100,
    },
    beforeUpload: {
      type: Function,
      default: null,
    },
    uploadFunc: {
      type: Function,
      default: null,
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    successTips: {
      type: String,
      default: '数据全部有效，即将跳转上传详情',
    },
  },
  data() {
    return {
      dialogDisplay: false,
      isButtonLoading: false,
      checking: 0,
      uploadFile: null,
      errorMsg: '',
      failedFileUrl: '',
      FILE_TYPES: {
        excel: {
          ext: ['xlsx'],
          accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
        },
        word: {
          ext: ['doc', 'docx'],
          accept: '',
        },
        image: {
          ext: ['jpg', 'png', 'bmp', 'jpeg'],
          accept: 'image/png,image/jpeg,image/jpg',
        },
      },
    };
  },
  methods: {
    openModal() {
      this.dialogDisplay = true;
    },
    closeModal() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.dialogDisplay = false;
      this.isButtonLoading = false;
      this.checking = 0;
      this.uploadFile = null;
      this.errorMsg = '';
      this.failedFileUrl = '';
    },
    async onUploadChange(file) {
      this.errorMsg = '';
      // 校验文件
      const fileNameArr = file.name.split('.');
      const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
      const extList = this.FILE_TYPES[this.accept].ext;
      if (file.size > (this.maxFileSize * 1024 * 1024)) {
        this.errorMsg = this.$t('message.validator.uploadFileTips', { ext: extList.join('/'), maxSize: `${this.maxFileSize}M` });
      } else if (this.accept && extList.indexOf(ext) === -1) {
        this.errorMsg = this.$t('message.validator.uploadFileTips', { ext: extList.join('/'), maxSize: `${this.maxFileSize}M` });
      } else if (this.beforeUpload) {
        await this.beforeUpload({ file });
      }
      this.uploadFile = {
        name: file.name,
        size: file.size,
        uploadTime: formatDateDisplay(new Date(), 'yyyy MM.dd HH:mm:ss'),
        raw: file.raw,
      };
    },

    onDownloadFile() {
      const fileUrl = window.URL.createObjectURL(this.uploadFile.raw);
      const tmpLink = document.createElement('a');
      tmpLink.href = fileUrl;
      tmpLink.download = this.uploadFile.name;
      document.body.appendChild(tmpLink);
      tmpLink.click();
      document.body.removeChild(tmpLink);
      URL.revokeObjectURL(fileUrl);
    },

    onDownloadFailedFile() {
      window.location.href = this.failedFileUrl;
      this.closeModal();
    },

    onDeleteFile() {
      this.checking = 0;
      this.uploadFile = null;
      this.errorMsg = '';
      this.failedFileUrl = '';
    },

    gerFileSize(size) {
      if (!size) {
        return '0KB';
      }
      const sizeM = +((size / 1024 / 1024).toFixed(2));
      if (sizeM >= 1) {
        return `${sizeM}M`;
      }
      const sizeKB = (size / 1024).toFixed(2);
      return `${sizeKB}KB`;
    },

    onReturn() {
      this.timer = setTimeout(() => {
        this.$router.push({
          path: this.redirectUrl || '/content/upload',
        });
        this.closeModal();
      }, 1000);
    },

    async onSubmit() {
      if (this.uploadFunc) {
        const data = new FormData();
        data.append('file', this.uploadFile.raw);
        this.checking = 1;
        try {
          const res = await this.uploadFunc(data);
          if (!res) { // 成功
            this.checking = 2;
            this.onReturn();
          } else { // 失败
            this.checking = 0;
            this.errorMsg = '存在无效数据';
            this.failedFileUrl = res;
          }
        } catch (err) {
          if (err.respCode === '00004|14006') {
            this.errorMsg = '表头错误, 请核验模板文件是否正确';
          } else if (err.respCode === '00004|14000') {
            this.errorMsg = 'No Data';
          } else {
            this.errorMsg = err.respMsg;
          }
          this.checking = 0;
          this.failedFileUrl = '';
        }
      }
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss">
.upload-modal {
  &.el-dialog {
    .el-dialog__header {
      padding: 16px;
      border-bottom: 1px solid rgba(0,32,63,0.08);
    }
    .el-dialog__body {
      padding: 30px 35px;
      padding-bottom: 32px;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
  .dialog-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    .dialog-close-icon {
      font-size: 23px;
      width: 27px !important;
      height: 27px !important;
      min-width: 27px !important;
      border-radius: 4px;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        display: flex;
      }

      .el-icon-close {
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
  }
  .upload-wrapper {
    width: 100%;
    .upload-box {
      width: 100%;
      .upload-top {
        display: flex;
        justify-content: flex-end;

        .download-temp {
          font-weight: 900;
          font-size: 14px;
          color: #00A2DD;
          line-height: 32px;
          cursor: pointer;
          margin: 0;
          padding: 0;
        }
      }
      .upload-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        .el-upload {
          width: 100%;
        }
        .el-upload-dragger {
          width: 100%;
          background: #F1F5F7;
          border: none;
          border-radius: 2px;
          height: 160px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .upload-tips {
          font-weight: 400;
          font-size: 14px;
          color: #264373;
          line-height: 32px;
        }

        .upload-content-info {
          font-weight: 900;
          font-size: 14px;
          color: #264373;
          line-height: 22px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .btn-upload {
            padding: 8px 16px;
            background: #00A2DD;
            border-radius: 4px;
            color: white;
          }
        }
      }
    }

    .file-box {
      border-radius: 4px;
      border: 2px solid #F1F5F7;
      padding: 10px;
      .file-info {
        display: flex;
        align-items: center;

        .file-icon {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #F1F5F7;
          margin-right: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon-other1 {
            font-size: 26px;
            color: #264373;
          }
        }

        .file-content {
          flex: 1;
          .file-name {
            font-weight: 900;
            font-size: 14px;
            color: #264373;
            line-height: 19px;
            margin: 0;
            margin-bottom: 8px;
          }
          .file-desc {
            margin: 0;
            font-weight: 400;
            font-size: 12px;
            color: #264373;
            line-height: 14px;
          }
        }

        .file-operate {
          color: #00A2DD;
          cursor: pointer;
          margin-left: 10px;
          width: 34px;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          font-size: 20px;

          &.iconfont {
            font-size: 28px;
            font-weight: 500;
          }

          &:hover {
            background: #F1F5F7;
          }
        }
      }

      .error-info {
        display: flex;
        align-items: center;
        padding: 10px 30px;
        border-top: 1px solid #F1F5F7;
        margin-top: 10px;
        .el-icon {
          color: #FF6F22;
          font-size: 21px;
        }
        .error-txt {
          font-weight: 500;
          font-size: 14px;
          color: #264373;
          line-height: 19px;
        }
      }
    }

    .success-box {
      border-radius: 4px;
      border: 2px solid #F1F5F7;
      padding: 10px;
      .success-info {
        display: flex;
        align-items: center;
        padding: 10px 30px;
        .el-icon {
          color: #67C23A;
          font-size: 21px;
        }
        .success-txt {
          font-weight: 500;
          font-size: 14px;
          color: #264373;
          line-height: 19px;
        }
      }
    }
  }

  .upload-btns {
    display: flex;
    justify-content: flex-end;
    padding: 14px 16px;
    border-top: 1px solid #EBEEF0;

    .rhcn-button {
      border-radius: 4px;
    }
  }
}
</style>
